import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import qs from "query-string";
import ProductCardForEditProductGroup from "../../../components/product-card/ProductCardForEditProductGroup/ProductCardForEditProductGroup";
import "./EditProductGroup.scss";
import { Redirect } from "react-router-dom"; //make sure to import all the components.
import Button from "@material-ui/core/Button";
import * as actionTypes from "../../../store/actions";
import "./EditProductGroup.scss";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import ReactLoader from "react-loader-spinner";
import { toast } from "react-toastify";
import paginate_styles from "../../../styles/modules/Pagination.module.scss";
// Dialog Dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import translator from "../../../utils/translator";

export class EditProductGroup extends Component {
	limit = 24; // Number of records per page
	pagination_count = 10; // Number of pagination buttons to show

	state = {
		groupName: qs.parse(this.props.location.search, {
			ignoreQueryPrefix: true
		}).groupName,
		productGroupId: qs.parse(this.props.location.search, {
			ignoreQueryPrefix: true
		}).productGroupId,
		productSearchTerm: "",
		totalResults: "",
		listOfProductsToDisplay: [],
		pages: [],
		redirect: null,
		listOfProductsForThisProductGroup: {},
		listOfProductCardsToDisplayForThisProductGroup: [],

		//for pagination
		whatIsTheNumberOfTheNext10Pages: 0,
		howManyPagesDidWePassBy: 0,
		didWeSearch: false,
		dialog: null,
		which_number_of_10_sets_are_we_on: 1, // this means we are on the first 10 pages

		// Product Shopping Version
		page: 1,
		hasNextPage: false,

		start_page: 1,
		products: [],
		totalResults: 0
	};

	toast_config = {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    };


	checkIfPageDisabled = (page, total) => {
		return (page - 1) * this.limit + 1 > total;
	};

	// ---- NEW VERSION ----
	searchForProducts = async () => {
		try {
			this.setState({
				didWeSearch: true,
				dialog: (
					<Dialog open={true} aria-labelledby="form-dialog-title">
						<DialogTitle id="form-dialog-title set-price-dialog-header">
							{translator("Misc", "loading_label")}{" "}
						</DialogTitle>
						<DialogContent
							style={{
								paddingRight: "10em"
							}}
						>
							<ReactLoader
								style={{
									marginLeft: "8em"
								}}
								type="Oval"
								color="#00BFFF"
								height={50}
								width={50}
							/>
						</DialogContent>
					</Dialog>
				)
			});
			// We could have done some of this in the productCard component but the reason I didn't is because I didn't know there was a way to have states in a functional component. I just found out now.
			
			const response = await Axios.post(
				this.props.APIUrl + "/products/search-beta",
				{
					query: this.state.productSearchTerm,
					limit: this.limit,
					page: this.state.page,
					language: this.props.selected_language,
				}
			);
			const { products, hasNextPage } = response.data;
			await this.setState({
				didWeSearch: true,
				dialog: null,
				products: [...products],
				hasNextPage: hasNextPage,
			});
		} catch (error) { }
	};

	removeProductFromGroup = () => { };

	callNewSearch = async () => {
		// Resets the pagination
		this.setState({ page: 1, start_page: 1 }, this.searchForProducts);
	};

	async componentDidMount() {
		try {
			await this.getProductListForThisProductGroup();
		} catch (error) { }
	}

	newPageOfProductsToDisplay = thisPageOfProducts => {
		this.setState({ listOfProductsToDisplay: thisPageOfProducts });
	};

	getProductListForThisProductGroup = async () => {
		let getProductListFromProductGroupApiURL =
			this.props.APIUrl + "/settings/product-groups/product";
		let data = {
			productGroupId: this.state.productGroupId
		};
		let getProductListFromProductGroupApiResponse = await Axios.post(
			getProductListFromProductGroupApiURL,
			data
		);

		await this.setState({
			listOfProductsForThisProductGroup:
				getProductListFromProductGroupApiResponse.data.reduce(
					(skuLookup, product) => ({
						...skuLookup,
						[product.sku]: product,
					}),
					{}
				)
		});

		let productsForThisProductGroup = getProductListFromProductGroupApiResponse.data;

		let listOfProductCardsToDisplayForThisProductGroup = await productsForThisProductGroup.map(
			(product, index) =>
				product.length === index ? ( // checking if it's the last product then add the class name as "product-card-table-data-cell-last"
					<div key={index} class="product-card-table-data-cell-last">
						{" "}
						{/* the difference with this ternary expression is the styles. you can seee the class for this one is last while the other one does not have it */}
						<ProductCardForEditProductGroup
							productIsInGroup={true}
							updateProductGroup={this.getProductListForThisProductGroup}
							productGroupId={this.state.productGroupId}
							sku={product.sku}
							imageURL={product.image}
							vendorName={product.vendorName}
							description={product.description}
							modelNumber={product.modelNumber}
							bullets={product.bullets}
							specsManual={product.specsManual}
							productName={product.name}
						/>
					</div>
				) : (
						<div key={index} class="product-card-table-data-cell">
							<ProductCardForEditProductGroup
								productIsInGroup={true}
								updateProductGroup={this.getProductListForThisProductGroup}
								productGroupId={this.state.productGroupId}
								sku={product.sku}
								imageURL={product.image}
								vendorName={product.vendorName}
								description={product.description}
								modelNumber={product.modelNumber}
								bullets={product.bullets}
								specsManual={product.specsManual}
								productName={product.name}
							/>
						</div>
					)
		);

		this.setState({
			listOfProductCardsToDisplayForThisProductGroup: listOfProductCardsToDisplayForThisProductGroup
		});
	};

	updateGroup = async () => {
		if(this.state.groupName === "" || this.state.groupName === undefined || this.state.groupName === null) {
			return toast.error(translator("Misc", "product_group_name_error"), this.toast_config);
		}
		let updateProductGroupAPIUrl = this.props.APIUrl + "/settings/product-groups/update";
		let data = {
			updatedGroupName: this.state.groupName,
			productGroupId: this.state.productGroupId
		};
		await Axios.post(updateProductGroupAPIUrl, data);

		let dialog_content = (
			<Dialog open={true} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					Success{" "}
				</DialogTitle>
				<DialogContent>You have successfully updated your product groups!</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							this.setState({ dialog: null });
						}}
						color="primary"
					>
						Okay
					</Button>
				</DialogActions>
			</Dialog>
		);

		this.setState({ dialog: dialog_content });
	};

	deleteGroup = async () => {
		let deleteProductGroupAPIUrl = this.props.APIUrl + "/settings/product-groups/delete";
		let data = {
			productGroupId: this.state.productGroupId
		};
		await Axios.post(deleteProductGroupAPIUrl, data);
		let redirect = <Redirect to="/settings/product-groups" />;
		let dialog_content = (
			<Dialog open={true} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					Success{" "}
				</DialogTitle>
				<DialogContent>
					You have successfully deleted a product groups! You will now be redirected back
					to the main page.
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							this.setState({ redirect: redirect });
						}}
						color="primary"
					>
						Okay
					</Button>
				</DialogActions>
			</Dialog>
		);

		this.setState({ dialog: dialog_content });
	};

	render() {
		let redirect = this.state.redirect;
		let listOfProductsInThisProductGroup = this.state
			.listOfProductCardsToDisplayForThisProductGroup
			? this.state.listOfProductCardsToDisplayForThisProductGroup
			: [];

		// ---- Product Shopping Pagination Version Variables Requirements ----

		let state = this.state;
		const currentOffset = (state.page - 1) * this.limit;
		const productCount = state.products.length;
		let main = (
			<>
				{redirect}
				{this.state.dialog}
				<div class="card user-profile-card">
				<div class="card-body">
					<h3>{translator("Admin Product Groups", "product_group_title")}</h3>

					<form class="form-inline">
						<label>{translator("Admin Product Groups", "group_name_label")}</label>
							<input
								class="form-control form-control-sm ml-3 w-75 "
								type="text"
								aria-label="Search"
								value={this.state.groupName}
								onChange={event => this.setState({ groupName: event.target.value })}
							/>
							<button
								onClick={this.updateGroup}
								style={{ paddingRight: "10rem" }}
								type="button"
								class="btn btn-outline-primary edit-product-group-button"
							>
								{translator("Admin Product Groups", "save_group_name_btn")}
							</button>
							<button
								style={{ marginTop: "2rem" }}
								onClick={this.deleteGroup}
								type="button"
								class="btn btn-outline-primary edit-product-group-button"
							>
								{translator("Admin Product Groups", "delete_group_btn")}
							</button>
						</form>
					</div>
				</div>
				<div className="card user-profile-card">
				<div class="card-body">
					<div className="labeltext">
						{translator("Admin Product Groups", "add_products_instruction")}
					</div>
						<div className="searchwrapper">
							<input
								onChange={event =>
									this.setState({ productSearchTerm: event.target.value })
								}
								class="form-control"
								type="text"
								placeholder={translator("Admin Product Groups", "search_placeholder")}
								aria-label="Search"
							/>
							<button
								type="button"
								class="btn btn-outline-primary"
								onClick={this.callNewSearch}
							>
								<i class="fa fa-search" />
							</button>
						</div>

						{/* Product Shopping Pagination Version */}
						{!!state.productSearchTerm && (
							<div className={paginate_styles.results_wrapper} style={{ marginTop: "3em" }}>
								<div className={paginate_styles.results}>
									{productCount
										? `Results ${currentOffset + 1} - ${currentOffset + productCount}`
										: translator("Misc", "no_results_found")}
								</div>
								<div className={paginate_styles.pagination_wrapper}>
									<button
										disabled={state.page <= 1}
										onClick={() =>
											this.setState(
												{
													page: state.page - 1
												},
												this.searchForProducts
											)
										}
									>
										<i class="far fa-arrow-alt-circle-left" />
									</button>
									<button
										disabled={!state.hasNextPage}
										onClick={() =>
											this.setState(
												{
													page: state.page + 1
												},
												this.searchForProducts
											)
										}
									>
										<i class="far fa-arrow-alt-circle-right" />
									</button>
								</div>
							</div>
						)}
						<hr />
						<div className="pg-columns">
							<div className="search-column">
								{state.products.map((product, index) => (
									<div key={index} class="product-card-table-data-cell">
										<ProductCardForEditProductGroup
											productIsInGroup={state.listOfProductsForThisProductGroup[product.sku]}
											updateProductGroup={this.getProductListForThisProductGroup}
											productGroupId={this.state.productGroupId}
											sku={product.sku}
											imageURL={product.image}
											vendorName={product.vendorName}
											description={product.description}
											modelNumber={product.modelNumber}
											bullets={product.bullets}
											specsManual={product.specsManual}
											productName={product.name}
										/>
									</div>
								))}
							</div>
						<div className="selected-column">
							<h3>{translator("Admin Product Groups", "selected_products_title")}</h3>
							{listOfProductsInThisProductGroup}
						</div>
						</div>
					</div>
				</div>
			</>
		);

		return (
			<SettingsWrapper
				header={translator("Admin Product Groups", "page_title")}
				main={main}
				classes={"edit-product-group-container"}
			/>
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	accountId: state.accountIdForTheProjectYouAreShoppingFor,
	productCards: state.listOfProductCardsToDisplay,
	selected_language: state.selected_language,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditProductGroup);
